import theme from "../../materialThemeOverrides";

const { primary, secondary, grey } = theme.palette;
const labelColor = "#333";

export const ThemeContainerStyle = {
    parent: {
        padding: "0 0 0 36px",
        width: 400,
        "& h4": {
            color: "#333"
        },
        "& hr": {
            margin: "30px 30px 10px 0px",
            background: "#bbb"
        }
    }
};
export const indexStyle = ({ palette }) => ({
    parent: {
        backgroundColor: "#f0f0f0",
        color: "#555",
        height: "100%",
        textTransform: "uppercase"
    },
    header: {
        padding: "8px 24px 14px",
        "& h2": {
            marginBottom: 8
        }
    },
    content: {
        paddingTop: 30,
        width: 400,
        overflowY: "auto",
        overflowX: "hidden",
        "& h4": {
            color: "#333",
            marginBottom: 12
        }
    },
    themeOptionsContainer: {
        display: "flex",
        flexDirection: "row",
        height: "100%"
    },
    navParent: {
        display: "flex",
        flexDirection: "column",
        // borderRight: "solid 1px #444"
        backgroundColor: "#333"
    },
    topNav: {
        marginTop: 0
    },
    loadTheme: {
        float: "right"
    },
    darkRound: {
        backgroundColor: palette.grey[800],
        color: "#333",
        boxShadow: "none",
        marginTop: -6,
        fontSize: 11,
        fontWeight: 600,
        "&:hover": {
            backgroundColor: palette.grey[700],
            color: "#333"
        },
        "& .material-icons": {
            marginRight: 6,
            fontSize: 20,
            color: "#fff"
        }
    }
});

export const themeOptionsStyls = {
    optionsParent: {
        display: "flex",
        position: "relative",
        marginLeft: -6,
        "& label": {
            fontSize: 10.5,
            width: "100%",
            left: 0,
            fontWeight: 500,
            color: "#555",
            marginTop: 8,
            display: "block",
            whiteSpace: "nowrap",
            textAlign: "center"
        }
    },
    item: {
        display: "inline-block",
        textAlign: "center",
        position: "relative",
        padding: 0,
        textTransform: "uppercase",
        borderRadius: 0,
        background: "#ccc",
        // border: `1px solid #555`,
        marginRight: 6,
        marginLeft: 6,
        "&:active, &:hover": {},
        "& img": {
            display: "block",
            width: 50
        },
        "&.selected": {
            backgroundColor: "#11a9ef",
            borderRadius: 0,
        },
        "&:disabled": {
            backgroundColor: "rgba(0,0,0,0.05)"
        },
        "&:disabled img": {
            opacity: 0.5
        }
    },
    dropDownParent: {
        marginTop: 18,
        "& h4": {
            float: "left",
            marginTop: 8,
            marginRight: 16
        }
    },
    tooltipPopper: {
        marginTop: -10,
        opacity: 1,
        fontSize: 12
    },
    tooltip: {
        fontSize: 12
    },
    title: {
        marginBottom: 14
    },
    row: {
        display: "flex"
    },
    lightText: {
        color: "#cbcbcb"
    },
    whiteTextInput: {
        "& input": {
            color: labelColor
        }
    },
    logoContainer: {
        width: "100%",
        marginTop: 12,
        "& > div": {
            marginRight: 20,
            display: "inline-block"
        }
    },
    whiteSelectInput: {
        padding: "14px 36px 14px 10px",
        color: "#fff",
        fontSize: 14
    },
    whiteSelectIcon: {
        color: grey[100]
    },
    greyLabel: {
        color: grey[100]
    }
};

export const fontControlStyles = {
    gray: {
        color: labelColor
    },
    uppercase: {
        textTransform: "uppercase"
    },
    parent: {
        display: "flex",
        alignItems: "center",
        width: "100%"
    },
    fontDropdown: {
        color: "#333",
        background: "white",
        width: 300,
        height: 33,
        display: "flex",
        alignItems: "center",
        paddingLeft: 10,
        marginTop: 10
    },
    fontOptions: {
        display: "inline-block",
        width: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        alignSelf: "center",
        textTransform: "none"
    },
    labelRoot: {
        alignItems: "flex-start",
        marginLeft: 0,
        width: "100%",
        marginBottom: 20,
        position: "relative",
        "&.fontSettings": {
            opacity: 0
        },
        "&:hover $.fontSettings": {
            opacity: 1
        }
    },
    label: {
        color: labelColor
    },
    dropDownIcon: {
        marginLeft: 5
    },
    settingsColor: {
        color: labelColor
    },
    fontSettingsPaper: {
        padding: 20,
        width: 250
    },
    fontSettings: {
        position: "absolute",
        right: 0,
        top: 20,
        "& button": {
            marginRight: 16
        }
    },
    fontSettingsSlider: {
        marginBottom: 20,
        "& label": {
            textTransform: "uppercase"
        }
    },
    fontSettingsOption: {
        marginRight: 10,
        display: "inline-block",
        minWidth: 150,
        "& label": {
            display: "block",
            marginBottom: 6,
            textTransform: "uppercase"
        }
    },
    settingsInput: {
        width: "100%",
        border: "solid 1px rgba(0,0,0,0.2)"
    },
    uploadFont: {
        fontSize: 16,
        color: "#333",
        justifyContent: "flex-start",
        padding: "12px 16px",
        borderTop: "solid 1px rgba(0,0,0,.2)",
        "&:hover": {
            background: "#50bbe6"
        }
    },
    defaultFont: {
        display: "inline-block",
        margin: "6px 6px 0 0",
        backgroundColor: grey[600],
        padding: "8px 10px",
        textAlign: "center",
        width: 156,
        height: 34,
        "& img": {
            position: "relative"
        },
        "&.selected": {
            backgroundColor: grey[800]
        }
    },
    fontListLabel: {
        textTransform: "uppercase",
        fontWeight: 500,
        color: grey[400],
        paddingLeft: 14,
        paddingTop: 14,
        display: "block"
    }
};

export const colorStyles = {
    paletteParent: {
        marginTop: 16,
        marginBottom: 8,
        "& h4": {
            float: "left",
            marginRight: 12,
            marginBottom: 2,
            marginTop: 1
        }
    },
    colorPickerParent: {
        width: 32,
        height: 32,
        borderRadius: "50%",
        // boxShadow: "1px 1px 3px #000",
        display: "inline-block",
        marginRight: 10,
        position: "relative",
        marginTop: 10,
        "& .material-icons": {
            opacity: 0,
            position: "absolute",
            top: -4,
            right: -4,
            fontSize: 16,
        },
        "&:hover .material-icons": {
            opacity: 1
        }
    },
    colorPicker: {
        height: "100%",
        width: "100%",
        borderRadius: "50%",
        border: "solid 1px #bbb"
    },
    themeParent: {
        position: "relative"
    },
    themeLabel: {
        position: "absolute",
        left: 10,
        top: 46
    },
    addNew: {
        width: 32,
        height: 32,
        borderRadius: 50,
        border: `2px solid #333`,
        display: "inline-block",
        // boxShadow: "1px 1px 4px #000",
        position: "relative",
        textAlign: "center",
        padding: 2,
        top: 10,
        "&:hover": {
            borderColor: primary[500],
            "& .material-icons": {
                color: primary[500]
            }
        },
        "& .material-icons": {
            color: "#444",
            fontWeight: 800
        },
        "&.firstChild": {
            marginBottom: 13
        },
        "&.hidden": {
            opacity: 0
        }
    },
    inlineRow: {
        display: "inline-block",
        marginRight: 12,
        "& .colorItem": {
            display: "inline-block"
        }
    },
    inlineFlex: {
        display: "inline-flex",
        flexWrap: "wrap",
        marginRight: 12,
        "& .colorItem": {
            display: "inline-block"
        }
    },
    themeColor: {
        position: "absolute",
        top: 0,
        left: 0
    },
    paletteSelection: {
        width: 600
    },
    label: {
        textAlign: "center",
        fontSize: 11,
        marginLeft: -10,
        marginBottom: 12,
        marginTop: 6
    }
};

export const colorPaletteStyles = {
    paletteOptions: {
        color: "#fff",
        cursor: "pointer",
        marginTop: -18,
        marginBottom: 36,
        width: 500,
        fontSize: 16,
        "& .material-icons": {
            position: "relative",
            top: 6
        }
    },
    label: {
        textTransform: "uppercase",
        color: "#333",
        display: "block",
        marginBottom: 6
    },
    palette: {
        width: 135,
        marginRight: 36,
        marginBottom: 12,
        display: "inline-block"
    },
    iconOption: {
        padding: 10,
        borderRadius: 8,
        "&.selected": {
            backgroundColor: grey[50]
        }
    },
    color: {
        width: 18,
        height: 18,
        borderRadius: "50%",
        display: "inline-block",
        marginRight: 4
    },
    icon: {
        width: 36,
        height: 36,
        display: "inline-block",
        marginRight: 2
    },
    whiteTextInput: {
        "& input": {
            color: labelColor,
            backgroundColor: "transparent"
        },
        "& input:disabled": {
            backgroundColor: "transparent"
        }
    }
};
